const iconNames: { [key: string]: string } = {
    // Add icons here if needed
};

export default iconNames;
